var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45801 14.4999C1.45801 7.57317 7.07293 1.95825 13.9997 1.95825C20.9264 1.95825 26.5413 7.57317 26.5413 14.4999C26.5413 21.4267 20.9264 27.0416 13.9997 27.0416C7.07293 27.0416 1.45801 21.4267 1.45801 14.4999ZM13.9997 3.70825C8.03942 3.70825 3.20801 8.53967 3.20801 14.4999C3.20801 20.4602 8.03942 25.2916 13.9997 25.2916C19.9599 25.2916 24.7913 20.4602 24.7913 14.4999C24.7913 8.53967 19.9599 3.70825 13.9997 3.70825ZM13.9997 7.79159C14.4829 7.79159 14.8747 8.18334 14.8747 8.66659V15.6666C14.8747 16.1498 14.4829 16.5416 13.9997 16.5416C13.5164 16.5416 13.1247 16.1498 13.1247 15.6666V8.66659C13.1247 8.18334 13.5164 7.79159 13.9997 7.79159ZM14.5999 19.6847C14.9575 20.0097 14.9839 20.5631 14.6588 20.9207L14.6471 20.9335C14.322 21.2911 13.7686 21.3174 13.4111 20.9924C13.0535 20.6673 13.0272 20.1139 13.3522 19.7563L13.3639 19.7435C13.689 19.3859 14.2424 19.3596 14.5999 19.6847Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/FAILURE.903b2a426def7626977af8c22b507e68.svg";
export { ForwardRef as ReactComponent };